import { insightoutAiEndpoint } from "./utils/env";
import { getToken } from "./utils/getToken";
import axios from "./axios";

export function fetchAi(uri: string, init: RequestInit) {
  const amendedInit = { ...init, headers: { ...init.headers } };
  if (init.headers && !("Authorization" in init.headers)) {
    amendedInit.headers["Authorization"] = `Bearer ${getToken()}`;
  }

  return fetch(`${insightoutAiEndpoint}${uri}`, amendedInit);
}

export async function submitMessageFeedback(
  conversationUuid: string,
  messageUuid: string,
  feedback: "thumbs_up" | "neutral" | "thumbs_down"
): Promise<void> {
  await axios.post(
    `/api/v1/ai-conversations/${conversationUuid}/messages/${messageUuid}/feedback`,
    { feedback }
  );
}
